import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../state'

import * as section from './section'

@ngCore.Component({
  // TODO: why?
  changeDetection: ngCore.ChangeDetectionStrategy.OnPush,
  imports: [section.Component],
  selector: 'atn-scenario-dropdown-overlay',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /** Opens the create scenario dialog from the dropdown overlay. */
  public addBtnClickedHandler() {
    if (
      !this.meFeature.contexts.selectors.currentUserCanCreateScenario.asSignal()
    ) {
      return
    }

    this.scenariosFeature.actions.openCreate
      .from('ScenarioOverlay.Buttons.Add.Clicked')
      .dispatch()
  }
}
